import React, { useMemo } from 'react';
import {
  IStandardRutinContext,
  StandardRutinContext,
} from './StandardRutinContext';

export const StandardRutinContextProvider: React.FC<
  React.PropsWithChildren<IStandardRutinContext>
> = props => {
  const value = useMemo<IStandardRutinContext>(() => {
    const aValue: IStandardRutinContext = {
      //tilldela till värde först för bättre typkontroll med excess properties checks
      rutinID: props.rutinID,
      collectionName: props.collectionName,
      urval: props.urval,
      setUrval: props.setUrval,
      columns: props.columns,
      setColumns: props.setColumns,
      formStateRef: props.formStateRef,
      setOpenChoiceDialog: props.setOpenChoiceDialog,
      refetchButtonQueries: props.refetchButtonQueries,
      urvalCacheInvalidation: props.urvalCacheInvalidation,
      addRefetchButtonQuery: props.addRefetchButtonQuery,
      selectNextDetail: props.selectNextDetail,
    };
    return aValue;
  }, [
    props.rutinID,
    props.collectionName,
    props.urval,
    props.setUrval,
    props.columns,
    props.setColumns,
    props.formStateRef,
    props.setOpenChoiceDialog,
    props.refetchButtonQueries,
    props.urvalCacheInvalidation,
    props.addRefetchButtonQuery,
    props.selectNextDetail,
  ]);
  return (
    <StandardRutinContext.Provider value={value}>
      {props.children}
    </StandardRutinContext.Provider>
  );
};
